import { useMemo } from "react";
import { useGetOauthConnectionsQuery } from "@ugitgud/legos/queries/auth";

export interface RsoSummoner {
  riotUserName: string;
  riotTagLine: string;
  regionId: string;
  iconId: number | string;
}

interface RsoMetadata {
  region_id?: string;
  icon_id?: number | string;
}

const parseRsoConnection = (
  providerUsername: string | null | undefined,
  metadata: RsoMetadata | null | undefined,
): RsoSummoner | null => {
  if (!providerUsername) return null;

  const lastHashIndex = providerUsername.lastIndexOf("#");
  if (lastHashIndex === -1) return null;

  const riotUserName = providerUsername.substring(0, lastHashIndex);
  const riotTagLine = providerUsername.substring(lastHashIndex + 1);
  const regionId = metadata?.region_id ?? "";
  const iconId = metadata?.icon_id ?? 0;

  if (!riotUserName || !riotTagLine) return null;

  return { riotUserName, riotTagLine, regionId, iconId };
};

export const useRsoConnection = () => {
  const { data, loading, error } = useGetOauthConnectionsQuery();

  const rsoConnection = data?.getOauthConnections?.find((conn) => conn?.providerName === "riot");
  const hasRsoConnection = !!rsoConnection;

  const summoner = useMemo(() => {
    return parseRsoConnection(rsoConnection?.providerUsername, rsoConnection?.metadata as RsoMetadata);
  }, [rsoConnection?.providerUsername, rsoConnection?.metadata]);

  return {
    hasRsoConnection,
    rsoConnection,
    summoner,
    loading,
    error,
  };
};
